module.exports = __webpack_public_path__ + "static/media/photo_021.496f4267.JPG";